<script setup lang="ts">
import SSFooter from '../components/footer/SSFooter.vue'
</script>

<template>
  <main class="ss-app__main" data-testid="ss-app-main-login-layout">
    <slot name="main-content" />
  </main>
  <SSFooter />
</template>
